import { TextVariant } from './types';

export const ONLINE_INFO_CONSTANTS: Record<string, TextVariant> = {
  step1Title: { common: '새틀라이트 참가 하기' },
  step1Content: {
    common: (
      <>
        <span>
          <strong>“JOPT X 피망 쇼다운 홀덤”</strong>
        </span>
        <br /> 아이콘이 달린 토너먼트에
        <br />
        참여해주세요!'
      </>
    ),
  },
  step1Warning: {
    common: (
      <>
        여러 장의 참가권을 <strong>복수 획득</strong>할 수 있습니다.
      </>
    ),
  },
  step2Title: { common: '오프라인 이벤트 참가 위한 개인 정보 동의' },
  step2Content: {
    common:
      '새틀라이트 참가를 위한\n개인정보 3자 제공 동의 후\n골드 또는 티켓을 내고 참가해주세요!',
  },
  step2Warning: { common: '동의하지 않는 경우 새틀라이트에 참가할 수 없습니다.' },
  step3Title: { common: '새틀라이트 입상하고 오프라인 이벤트 참가권 획득하기' },
  step3Content: {
    common: (
      <>
        <span>
          <strong>새틀라이트</strong> 대회 당 4장 시트
        </span>
        <br /> 인더머니 순위를 기록하고 우승자 아바타와 오프라인 이벤트 참가권을 획득해주세요!
      </>
    ),
    pc: (
      <>
        <span>
          <strong>새틀라이트</strong> 대회 당 4장 시트
        </span>
        <br /> 인더머니 순위를 기록하고 우승자 아바타와 오프라인 이벤트 참가권을 획득해주세요!
      </>
    ),
  },
  step3Warning1: {
    common:
      '새틀라이트 참가 인원이 4명 이하인 경우 추가 등록 마감 시간 전에 대회가 종료될 수 있습니다.',
  },
  step3Warning2: { common: '남은 최대 엔트리 수에 따라 엔트리가 불가능 할 수 있습니다.' },
  step4Title: { common: '오프라인 이벤트 참가를 위한 참가권 확인' },
  step4Content: {
    common:
      '오프라인 이벤트 참가권을 획득했다면\n참가권 번호를 확인 후 오프라인 이벤트에\n참가해주세요!',
  },
};
